
import React from 'react';
import '../FundingModule.css';
import { CardContainer, Col, Row } from '../../../importCL';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';

interface IFundingCards {
    title?: string;
    selectedFundingType: string;
    setSelectedFundingType: React.Dispatch<React.SetStateAction<string>>;
    debitHelperText?: string;
    bankHelperText?:string;                         
}

const FundingModuleSelectableCards = ({
    title = 'Choose Your Funding Method',
    selectedFundingType,
    debitHelperText,
    bankHelperText,
    setSelectedFundingType}: IFundingCards) => {
        
    return(
        <Col>
            <h2 className='primary text-2xl'>{transformHTMLParserLinks(title)}</h2>
            <Row justify='start' className='mt-6 gap-4 mb-8 md:gap-6'>
                <Col className='flex flex-col relative text-center h-auto cursor-pointer' md={3}
                    onClick={() => setSelectedFundingType('debit')}>
                    <CardContainer className={`flex flex-col h-full ${selectedFundingType === 'debit' ? '!bg-primary-lightest primary': ''}`} 
                    borderSettings={{
                        display:true, 
                        squareBorder:false, 
                        borderRadiusMedium:false,
                        borderColor: selectedFundingType === 'debit' ? 'blue-creditone': 'grey-80'
                    }}>
                        Debit Card
                        <p className='!mb-0 mt-6'>{transformHTMLParserLinks(debitHelperText)}</p>
                    </CardContainer>
                </Col>
             <Col className='text-center h-auto cursor-pointer' md={3} 
                onClick={() => setSelectedFundingType('bank')}>
                    <CardContainer className={`flex flex-col h-full ${selectedFundingType === 'bank' ? '!bg-primary-lightest primary': ''}`}
                        borderSettings={{
                            display:true, 
                            squareBorder:false, 
                            borderRadiusMedium:false,
                            borderColor: selectedFundingType === 'bank' ? 'blue-creditone': 'grey-80'
                        }}>
                        Bank Account
                        <p className='!mb-0 mt-6'>{transformHTMLParserLinks(bankHelperText)}</p>
                    </CardContainer>
                </Col>
            </Row>
        </Col>
)
};

export default FundingModuleSelectableCards;